import { Tooltip } from "@mui/material";
import { CLIENT_VIEW_READ_ONLY_TOOLTIP } from "hooks/useViewAs";

interface ReadOnlyTooltipProps {
  /** When false the children render untouched. */
  active: boolean;
  title?: string;
  placement?: "top" | "bottom" | "left" | "right" | "bottom-end";
  /** The wrapper takes the full width, for a control that fills its row. */
  fullWidth?: boolean;
  children: React.ReactElement;
}

// MUI swallows events on a disabled element, so the tooltip needs a plain
// wrapper to hang off.
export default function ReadOnlyTooltip({
  active,
  title,
  placement = "top",
  fullWidth = false,
  children,
}: ReadOnlyTooltipProps) {
  if (!active) return children;
  return (
    <Tooltip
      title={title ?? CLIENT_VIEW_READ_ONLY_TOOLTIP}
      placement={placement}
    >
      <span
        style={{
          display: fullWidth ? "block" : "inline-flex",
          alignItems: "center",
          maxWidth: "100%",
          width: fullWidth ? "100%" : undefined,
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
}
